import React from 'react';

import { makeIconDef } from '../../makeIconDef';

export const FacebookIconDef = {
  'facebook': makeIconDef('facebook', {
    regular: () => <path d="M12 1C5.92422 1 1 5.95422 1 12.067C1 17.5919 5.02187 22.17 10.2812 23V15.2661H7.48828V12.067H10.2812V9.62881C10.2812 6.85557 11.9227 5.32305 14.4363 5.32305C15.6395 5.32305 16.8984 5.5392 16.8984 5.5392V8.26272H15.5105C14.1441 8.26272 13.7188 9.11653 13.7188 9.99194V12.067H16.7695L16.2818 15.2661H13.7188V23C18.9781 22.17 23 17.5919 23 12.067C23 5.95422 18.0758 1 12 1Z" fill="currentColor" />,
  })
}